import React, { Component } from "react";
import TextMask from "react-text-mask";
import { fullWidthToHalfWidth } from "checkout/ts/utils/numbers";
import { isChrome, isWindows } from "common/utils/browser";

const CARD_CVV_MASK: (string | RegExp)[] = [/[0-9０-９]/, /[0-9０-９]/, /[0-9０-９]/, /[0-9０-９]/];

export type CardCVVInputProps = Omit<React.InputHTMLAttributes<HTMLInputElement>, "onChange"> & {
    onChange?: (value: string) => void;
};

export class CardCVVInput extends Component<CardCVVInputProps> {
    handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { value: eventValue } = event.target as HTMLInputElement;
        this.props.onChange?.(fullWidthToHalfWidth(eventValue));
    };

    render() {
        const { value = "", ...props } = this.props;

        const skipAutoFormatting = isChrome() && isWindows();
        const disableFormattingOnCapture = (event) => {
            event.stopPropagation();
            event.preventDefault();
            return false;
        };

        return (
            <TextMask
                {...props}
                autoComplete="cc-csc"
                type="tel"
                pattern="[0-9０-９]*"
                inputMode={skipAutoFormatting ? "search" : "numeric"}
                guide={false}
                keepCharPositions={false}
                mask={CARD_CVV_MASK}
                placeholderChar={"\u2000"}
                onChange={this.handleChange}
                onInputCapture={skipAutoFormatting ? disableFormattingOnCapture : undefined}
                value={skipAutoFormatting ? String(value) : fullWidthToHalfWidth(String(value))}
            />
        );
    }
}
